import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useQualification } from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import { Question } from 'qualification/schema/model';
import PriceStepperField from 'system/components/ButtonGroupSelect/PriceStepperField';

interface Props {
  question: Extract<Question, { id: 'price_per_person' }>;
}

function PriceStepper({ question }: Props) {
  const { state, actions, answerOf } = useQualification();

  const handleChange = (value: number | string) => {
    if (Number(value) < 1) {
      return;
    }

    actions.answerQuestion(question.id, value);
  };

  const { t } = useTranslation('qualification');

  if (state.status !== QUALIFICATION_STATUS.answering) {
    return null;
  }

  const minOrderNumber = state.qualification.answers.min_order_number;
  const answer = answerOf(question.id);
  const errors = state.qualification.errors[question.id] || [];

  return (
    <>
      <Wrapper
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        alignItems={{ xs: 'center', sm: 'baseline' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        flexShrink="0"
        mt={{ xs: 5, sm: 5 }}
      >
        <Typography variant="body2" fontWeight={600} pb={{ xs: 2, sm: 0 }}>
          {t('budgetPerPerson')}
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          <PriceStepperField
            name={question.id}
            id={question.id}
            min={0}
            error={!!errors.length}
            value={(answer && Math.floor(answer)) || 0}
            onChange={handleChange}
          />
          <Box display="flex" alignItems="center" width={'fill-available'}>
            <Typography
              variant="body2"
              fontWeight={600}
              mt={4}
              style={{
                width: '100%',
                textAlign: 'end',
              }}
            >
              {t('amountPeople', {
                amount: minOrderNumber,
              })}
            </Typography>
          </Box>
        </Box>
      </Wrapper>
      <Box maxWidth={400} mx={'auto'}></Box>
    </>
  );
}

const Wrapper = styled(Box)`
  column-gap: ${({ theme }) => theme.spacing(7)}px;
  row-gap: ${({ theme }) => theme.spacing(1)}px;
`;

export default PriceStepper;
